import Long from "long";
import _m0 from "protobufjs/minimal";
import { MediaSource } from "../../content/media_source";
import { Asset_AssetType } from "../../content/asset";
export const protobufPackage = "snapchat.cdp.cof";
export interface MdpMediaAttribution {
    mediaSource: MediaSource;
    assetType: Asset_AssetType;
}
function createBaseMdpMediaAttribution(): MdpMediaAttribution {
    return { mediaSource: 0, assetType: 0 };
}
export const MdpMediaAttribution = {
    encode(message: MdpMediaAttribution, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.mediaSource !== 0) {
            writer.uint32(8).int32(message.mediaSource);
        }
        if (message.assetType !== 0) {
            writer.uint32(16).int32(message.assetType);
        }
        return writer;
    },
    decode(input: _m0.Reader | Uint8Array, length?: number): MdpMediaAttribution {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMdpMediaAttribution();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.mediaSource = reader.int32() as any;
                    break;
                case 2:
                    message.assetType = reader.int32() as any;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial<I extends Exact<DeepPartial<MdpMediaAttribution>, I>>(object: I): MdpMediaAttribution {
        const message = createBaseMdpMediaAttribution();
        message.mediaSource = object.mediaSource ?? 0;
        message.assetType = object.assetType ?? 0;
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long as any;
    _m0.configure();
}
